import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from '../../../shareModule/services/auth-service.service';
import { LocalServiceService } from '../../../shareModule/services/local-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { Clipboard } from '@angular/cdk/clipboard';
import { environment } from '../../../../environments/environment';
import { Title } from '@angular/platform-browser';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { Location } from '@angular/common';
import Swal from 'sweetalert2';
import { VerifyEmailPopupComponent } from 'src/app/shareModule/component/verify-email-popup/verify-email-popup.component';
import { select, Store } from '@ngrx/store';
import { selectUser } from 'src/app/shareModule/states/user-details';
import { Subject, takeUntil } from 'rxjs';
import { User } from 'src/app/shareModule/models/user.model';
import { AppState } from 'src/app/shareModule/states/app.state';

@Component({
  selector: 'app-giveaway',
  templateUrl: './giveaway.component.html',
  styleUrls: ['./giveaway.component.scss'],
})
export class GiveawayComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('giveawayModal', { static: true }) giveawayModal: TemplateRef<any>;
  @ViewChild('VerifEmailPopup') VerifEmailPopup: VerifyEmailPopupComponent;

  constructor(
    private location: Location,
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private clipboard: Clipboard,
    private router: Router,
    private sharedService: SharedService,
    private title: Title,
    private commonService: CommonService,
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
    @Inject("WINDOW") private window: any,
  ) {
    this.title.setTitle(`Giveaway | KACHIING`);
  }

  private modalRef: any;
  isLogin: any = 0;
  isLoading: boolean = false;
  hasParticipate: boolean = false;
  appUserId: any;
  subRegion: any;
  giveaways: any = [];
  giveaway: any = {
    showSurvey: false,
  };

  imgUrl = environment.ImageUrl;
  activeIndex: number = 1;
  activeImage: string;
  tabs = [
    { title: "Description" },
    { title: "Result", condition: false },
  ]
  defaultTabIndex: number = 0;
  private destroy$ = new Subject<void>(); // Emits on destroy
  user: User;

  ngOnInit() {

    this.local.getUserDetailsObserver()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: any) => {
        this.appUserId = user?.id;
        this.isLogin = user ? 1 : 0;
        this.subRegion = user?.region;
        this.cdr.detectChanges();
      });

    this.store
      .pipe(select(selectUser))
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: User) => {
        this.user = response;
        this.cdr.detectChanges();
      });
  }

  ngAfterViewInit(): void {
    const getUser = this.local.getUser();
    if (getUser) {
      this.appUserId = getUser.id;
      this.subRegion = getUser.region;
      this.initGiveaway();
    } else {
      this.initGiveaway();
    }
  }

  ngOnDestroy(): void {
    this.giveaways.forEach((row: any) => clearInterval(row.interval));
    this.destroy$.next();
    this.destroy$.complete();
  }

  isAdmin = () => this.local.getUser()?.role == 'admin';
  isModerator = () => this.local.getUser()?.role == 'moderator';
  isOwnMessage = (data: any) => {
    const user = this.local.getUser();
    if (!user) return false;

    return this.isAdmin() ? user.id == data.createdBy && data.isAdmin : user.id == data.createdBy && !data.isAdmin;
  };

  initGiveaway() {
    this.auth.giveaway_fetch({ subRegion: this.subRegion })
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        this.giveaways = response.body.data;
        this.giveaways.forEach((row: any, index: number) => {
          if (index === 0) row.isActive = true;
          if (this.sharedService.isBrowser() && row.endDate) {
            this.startCountdown(row);
          }
          row.moreThan1Day = false;
          if (row.endDate)
            row.remainingTime = '00:00:00';
          else
            row.remainingTime = `${row.participantLimit} Limit`;
          const startDate = moment(row.startDate).valueOf();
          const endDate = moment(row.endDate).valueOf();
          const now = moment().valueOf();

          row.participants = row.giveaway_participants.length;
          if (row.endDate) {
            row.hasExpired = endDate < now;
          } else {
            row.hasExpired = row.participants >= row.participantLimit;
          }
          row.hasParticipate = row.giveaway_participants.some((val: any) => val.userId === this.appUserId);
          row.images = Array.isArray(row.images) ? row.images : JSON.parse(row.images);
          row.activeImage = row.images[0];

          if (this.giveaway?.id == row.id) {
            this.giveaway = row
          }
        });
        this.showDetail();
        this.cdr.detectChanges();
      });
  }

  startCountdown(item: any): void {
    if (this.sharedService.isBrowser()) {
      item.interval = setInterval(() => {
        const now = new Date().getTime();
        const distance = new Date(item.endDate).getTime() - now;

        if (distance < 0) {
          clearInterval(item.interval);
          item.hasExpired = true;
          item.moreThan1Day = true;
          item.remainingTime = "Time's up!";
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (days > 0) {
          item.remainingTime = `${days} Day${days > 1 ? 's' : ''}`;
          item.moreThan1Day = true;
        } else {
          item.moreThan1Day = false;
          item.remainingTime = `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
        }
      }, 1000);
    }
  }

  handleParticipate(item: any, withoutDismiss: boolean = false, isUnparticipate: boolean = false) {
    if (this.isLogin === 0) {
      this.commonService.clickButton('loginBtn');
      return this.toastr.error('Please Login First !');
    }
    if (!withoutDismiss) this.modalService.dismissAll();
    this.isLoading = true;

    const payload = {
      giveawayId: item.id,
      isAdmin: this.isAdmin(),
    };

    this.local.alertConfirm({
      message: `Are you sure want to ${isUnparticipate ? 'unparticipate' : 'participate'} this giveaway ?`,
      title: 'Notice',
      fontAwesomeIcon: 'fa-gift'
    }).then((resp: any) => {
      if (resp.isConfirmed) {
        this.local.alertLoading({});
        // Giveaway participate
        this.auth.giveaway_participate(payload).subscribe((response: any) => {
          this.local.alertSuccess({
            message: response.message,
            showCancelButton: !isUnparticipate
          }).then((resp: any) => {
            if (resp.isConfirmed && !isUnparticipate) {
              // Show Form Email after Success Joined
              this.local.alertEmail()
                .then((resp) => {
                  const email = resp?.value?.emailFeedback
                  this.local.alertLoading({})
                  this.auth.giveaway_addEmail({
                    giveawayId: item.id,
                    email: email
                  }).subscribe((response: any) => {
                    Swal.close()
                  })
                })
            }
          })
          this.hasParticipate = true;
          this.initGiveaway();
          if (!withoutDismiss) this.modalService.dismissAll();
        }, (e) => {
          console.log(e);
          // Show Email Box when No Verified Yet
          this.local.alertError({
            message: e.error?.message,
            title: 'Sorry',
            cancelButtonText: (e.error?.message?.includes('email') ? 'Verify Email' : null)
          }).then((r: any) => {
            if (r?.dismiss == 'cancel') {
              this.VerifEmailPopup.openPopup()
            }
          })
        });
      }
    }).finally(() => {
      this.isLoading = false;
    });
  }

  openGiveawayModal(modal: any, item: any): void {
    this.modalService.dismissAll();
    this.fillDetail(item);
    this.modalRef = this.modalService.open(modal, {
      windowClass: 'giveaway_modal',
    });
    this.modalRef.dismissed.subscribe(() => {
      this.location.replaceState('/giveaway');
    });
  }

  fillDetail(item: any) {
    this.giveaway = item;
    this.giveaway.showSurvey = false;
    this.giveaway.hasSurvey = false;
    this.giveaway.haveWinner = item.giveaway_participants.some((row: any) => row.isWinner);
    if (this.giveaway.haveWinner) {
      this.giveaway.winner = item.giveaway_participants.find((row: any) => row.isWinner);
    }
    this.tabs[1].condition = this.giveaway.hasExpired;
    if (!this.router.url.includes('uuid')) {
      this.location.replaceState('/giveaway?uuid=' + item.uuid);
    }
    this.activeImage = item.images[0];
  }

  share(item) {
    navigator.share({
      title: `Giveaway ${item.name}`,
      text: `Check out this amazing giveaway: ${item.name}!`,
      url: `${environment.baseUrl}/giveaway?uuid=${item.uuid}`,
    })
      .then(() => console.log("Shared successfully"))
      .catch((e) => {
        alert(e.error.message);
      });
  }

  handlePagination(value: number) {
    const length = this.giveaways.length - 1;
    let index = length + value;
    index = index < 0 ? length - 1 : index;
    index = index > length - 1 ? index - 1 : index;
    this.activeIndex = index + 1;

    this.giveaways.forEach((row: any, i: number) => {
      row.isActive = i === index;
    });
  }

  handlePaginationImage(item: any, value: number) {
    const length = item.images.length - 1;
    let index = length + value;
    index = index < 0 ? length - 1 : index;
    index = index > length - 1 ? index - 1 : index;

    if (item.images[index] !== undefined) item.activeImage = item.images[index];
  }

  showDetail() {
    this.route.queryParams.subscribe((params) => {
      const uuid = params.uuid;
      const winner = params.winner
      this.defaultTabIndex = 1;
      if (winner) {
      }
      const data = this.giveaways.filter((row: any) => row.uuid === uuid);
      if (uuid && data.length > 0) {
        this.openGiveawayModal(this.giveawayModal, data[0]);
      }
    });

    if (this.giveaway?.id) {
      this.fillDetail(this.giveaway);
    }
  }

  copyLink(type: string, item: any) {
    if (this.sharedService.isBrowser()) {
      const currentUrl = this.window.location.href;
      this.clipboard.copy(`${currentUrl}?uuid=${item.uuid}`);
      this.toastr.success(`${type.toLocaleUpperCase()} Link Copied`);
    }
  }

  hasCheckedGiveaway(data: any) {
    return data.some((row: any) => row.userId === this.appUserId);
  }

  likeGiveaway(giveawayId: number, data: any) {
    if (this.isLogin === 0) {
      return this.toastr.error('Please Login First !');
    }
    const payload = {
      userId: this.appUserId,
      giveawayId: giveawayId,
      isAdmin: this.isAdmin(),
    };

    if (this.hasCheckedGiveaway(data.giveawayLikes)) {
      data.giveawayLikes = data.giveawayLikes.filter((row: any) => row.userId !== this.appUserId);
    } else {
      data.giveawayLikes = [...data.giveawayLikes, payload];
    }

    this.auth.giveaway_likes(payload).subscribe();
  }
}
